import { render, staticRenderFns } from "./StockLocal.vue?vue&type=template&id=81856d08&"
import script from "./StockLocal.vue?vue&type=script&lang=js&"
export * from "./StockLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports